document.addEventListener('click', function (e) {
  const btn = e.target.closest('.swym-button');
  if (!btn) return;

  // Toggle class
  btn.classList.toggle('swym-added');

  // Toggle aria for accessibility
  if (btn.classList.contains('swym-added')) {
    btn.setAttribute('aria-pressed', 'true');
  } else {
    btn.setAttribute('aria-pressed', 'false');
  }
});

(function () {
  let lastCount = null;

  function updateCartCount() {
    return fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const el = document.querySelector('[data-cart-count], .cart-count, #CartCount');
        if (!el) return false;

        if (lastCount === null) lastCount = cart.item_count;

        // If count changed → update UI
        if (cart.item_count !== lastCount) {
          el.innerText = cart.item_count;
          lastCount = cart.item_count;
          return true;
        }
        return false;
      })
      .catch(() => false);
  }

  // Observe any click and start smart polling
  document.addEventListener(
    'click',
    function () {
      let tries = 0;
      (async function poll() {
        while (tries <= 10) {
          tries++;
          if (await updateCartCount()) return;
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
      })();
    },
    true
  );
})();

document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const isInVennApp = params.get('sales_channel') === 'venn_apps';

  if (isInVennApp) {
    document.querySelector('header')?.remove();
    document.querySelector('footer')?.remove();

    window.Shopify = window.Shopify || {};
    window.Shopify.theme = window.Shopify.theme || {};
    window.Shopify.theme.cartRedirect = false;
  }
});

window.addEventListener(
  'scroll',
  function () {
    const btn = document.getElementById('scrollToTop');
    if (window.scrollY > 300) {
      btn.style.display = 'block';
    } else {
      btn.style.display = 'none';
    }
  },
  { passive: true }
);

document.getElementById('scrollToTop').addEventListener('click', function () {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.addEventListener('DOMContentLoaded', function () {
  try {
    // Updated selector
    var anchor = document.querySelector('a.swym-wishlist');
    if (!anchor) {
      console.warn('Wishlist link not found (selector a.swym-wishlist).');
      return;
    }

    function detectLangPrefix() {
      var path = window.location.pathname || '/';
      var m = path.match(/^\/([a-z]{2})(?:\/|$)/i);
      if (m) return '/' + m[1];

      var qp = new URLSearchParams(window.location.search).get('locale');
      if (qp && qp.length <= 5) return '/' + qp;

      var html = document.documentElement;
      if (html.getAttribute('lang')?.indexOf('ar') === 0) return '/ar';
      if (html.getAttribute('dir') === 'rtl') return '/ar';

      return '';
    }

    function buildWishlistUrl() {
      var prefix = detectLangPrefix();
      return (prefix ? prefix : '') + '/pages/swym-wishlist';
    }

    function applyWishlistUrl() {
      var url = buildWishlistUrl();
      anchor.setAttribute('href', url);

      anchor.addEventListener(
        'click',
        function (evt) {
          if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.button === 1) return;
          evt.preventDefault();
          window.location.href = url;
        },
        { once: false, passive: false }
      );
    }

    applyWishlistUrl();

    // Watch for href changes
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'href') {
          var expected = buildWishlistUrl();
          if (anchor.getAttribute('href') !== expected) {
            anchor.setAttribute('href', expected);
          }
        }
      });
    });
    observer.observe(anchor, { attributes: true, attributeFilter: ['href'] });

    // Extra fallback
    var tries = 0;
    var reapplyInterval = setInterval(function () {
      tries++;
      var expected = buildWishlistUrl();
      if (anchor.getAttribute('href') !== expected) anchor.setAttribute('href', expected);
      if (tries > 10) clearInterval(reapplyInterval);
    }, 300);

    console.info('Wishlist href fixer applied ->', anchor.getAttribute('href'));
  } catch (e) {
    console.error('Wishlist fixer error', e);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/account') {
    window.location.href = '/';
  }
});
